import {useMutation} from '@tanstack/react-query'
import {useGetAvailabilitiesApiMethod} from 'api/useGetAvailabilitiesApiMethod'
import {zipObject} from 'lodash'
import {Params} from 'types'

export const useGetAvailabilitiesMutation = () => {
  const getAvailabilities = useGetAvailabilitiesApiMethod()

  return useMutation({
    mutationFn: async (params: Omit<Params.GetAvailabilities, 'optionId'> & {optionIds: string[]}) => {
      const availabilityData = await Promise.all(
        params.optionIds.map((optionId) => getAvailabilities({...params, optionId}))
      )

      return zipObject(params.optionIds, availabilityData)
    },
  })
}
